<template>
  <div>
    <CAP0530_co :key="componentKey" @reload="forceReload"/>
  </div>
</template>

<script>
import CAP0530_co from './CAP0530_co.vue'

export default {
  name: "MENU_CAP0560",
  components: {
    CAP0530_co
  },
  data() {
    return {
      componentKey: 0
    };
  },
  methods: {
    forceReload() {
      this.componentKey += 1;
    }
  }
}
</script>
